import React, { Fragment, useEffect, useState } from "react";
import {
  Box,
  Divider,
  Tooltip,
  Grid,
  ImageList,
  ImageListItem,
  Typography,
  IconButton,
  Dialog,
} from "@mui/material";
import DirectionsCarRoundedIcon from "@mui/icons-material/DirectionsCarRounded";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import MonetizationOnOutlinedIcon from "@mui/icons-material/MonetizationOnOutlined";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { PrimaryButton } from "components/Buttons";
import { ErrorToaster } from "components/Toaster";
import Colors from "assets/Style/Colors";
import JSZip from "jszip";
import { Icons, FontFamily } from "assets";
import CustomerServices from "services/Customer";
import VehicleBookingServices from "services/VehicleBooking";
import moment from "moment";
import UploadedFile from "components/UploadedFile";
import ReactImageMagnify from "react-image-magnify";
import {
  CloudDownload,
  FullscreenOutlined,
  HdOutlined,
  CancelOutlined,
} from "@mui/icons-material";
import "viewerjs/dist/viewer.css";
import ImageLightBox from "components/ImageLightBox";
import axios from "axios";
import { saveAs } from "file-saver";
import FsLightbox from "fslightbox-react";
import { Button } from "@mui/base";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";

function VehicleBookingDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { state } = useLocation();
  console.log(state, "statestatestate");
  const [toggler, setToggler] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [baseUrlImages, setbaseUrlImages] = useState([]);
  const [open, setOpen] = React.useState(false);

  // *For Vehicle Detail
  const [vehicleDetails, setVehicleDetails] = useState();
  const [customerDetails, setCustomerDetails] = useState();
  const [slidePictures, setSlidePictures] = useState([]);

  // *For Pictures
  const [pictures, setPictures] = useState([]);
  const [imageIndex, setImageIndex] = useState(0);
  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return moment(dateString).format("DD-MM-YYYY");
  };
  const openLightbox = () => {
    const picturesWithBaseUrl = pictures.map(
      (picture) => process.env.REACT_APP_IMAGE_BASE_URL + picture
    );
    let pics = [
      "https://images.unsplash.com/photo-1525609004556-c46c7d6cf023?q=80&w=1000&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8Nnx8Y2Fyc3xlbnwwfHwwfHx8MA%3D%3D",
    ];
    setbaseUrlImages(picturesWithBaseUrl);

    setToggler(!toggler);
  };
  const handleCounter = (move) => {
    if (move == "left") {
      setImageIndex(imageIndex - 1);
    } else {
      setImageIndex(imageIndex + 1);
    }
  };
  // *For Get Customer Booking
  const getCustomerBooking = async (id) => {
    try {
      const { data } = await CustomerServices.getCustomerBooking();
      setCustomerDetails(data?.customers.find((e) => e.id === id));
    } catch (error) {
      ErrorToaster(error);
    }
  };
  //*Download Zip Function
  const handleDownloadClick = () => {
    const zip = new JSZip();

    const downloadPromises = pictures.map((imagePath) =>
      fetch(`${process.env.REACT_APP_IMAGE_BASE_URL}${imagePath}`)
        .then((response) => response.blob())
        .then((data) => {
          const filename = imagePath.split("/").pop();
          zip.file(filename, data);
        })
    );

    Promise.all(downloadPromises).then(() => {
      zip.generateAsync({ type: "blob" }).then((blob) => {
        const zipFilename = "images.zip";
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = zipFilename;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
      });
    });
  };

  // Helper function to display value or fallback
  const displayValue = (value, fallback = "N/A") => {
    return value || fallback;
  };

  // *For Get Vehicle Booking Detail
  const getVehicleBookingDetail = async () => {
    try {
      let params = { booking_id: id };
      if (state?.shipping) {
        params.shipping_details = true;
      }
      const { data } = await VehicleBookingServices.getVehicleBookingDetail(
        params
      );
      const { details } = data;
      setVehicleDetails(details);
      setPictures(details?.pictures);
      console.log(details?.pictures);

      let slides = details?.pictures?.map((item, index) => {
        return {
          src: item?.includes("https")
            ? item
            : process.env.REACT_APP_IMAGE_BASE_URL + item,
          alt: `image${index}`,
          width: 3840,
          height: 2560,
        };
      });
      setSlidePictures(slides);

      getCustomerBooking(details?.customer_id);
    } catch (error) {
      ErrorToaster(error);
    }
  };

  useEffect(() => {
    if (id) {
      getVehicleBookingDetail();
    }
  }, [id]);

  return (
    <Box>
      <Box
        sx={{
          m: 4,
          //   p: 2,
          //   bgcolor: Colors.white,
          borderRadius: 3,
          //   boxShadow: "0px 8px 18px 0px #9B9B9B1A",
        }}
      >
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12}>
            <Box
              sx={{
                //   mx: 4,
                mb: 4,
                p: 3,
                bgcolor: Colors.white,
                borderRadius: "12px",
                boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.08)",
                borderTop: "4px solid #001f3f",
              }}
            >
              <Typography
                variant="h4"
                sx={{
                  color: "#1a1a1a",
                  fontWeight: 700,
                  fontSize: "1.75rem",
                  letterSpacing: "-0.5px",
                }}
              >
                Vehicle Booking Details
              </Typography>
            </Box>
          </Grid>

          <Lightbox
            open={open}
            close={() => setOpen(false)}
            slides={slidePictures}
          />
          <Grid item xs={12} sm={5.5} sx={{ position: "relative" }}>
            <Box
              display={"flex"}
              justifyContent={"space-between"}
              sx={{ position: "absolute", top: "20%", zIndex: 1, width: "97%" }}
            >
              {
                <button
                  style={{ border: "none", backgroundColor: "transparent" }}
                  disabled={imageIndex != 0 ? false : true}
                  onClick={() => handleCounter("left")}
                >
                  <ChevronLeftIcon
                    sx={{ color: "white", fontSize: "40px", cursor: "pointer" }}
                  />
                </button>
              }
              {
                <button
                  style={{ border: "none", backgroundColor: "transparent" }}
                  disabled={imageIndex != pictures?.length - 1 ? false : true}
                  onClick={() => handleCounter("right")}
                >
                  <ChevronRightIcon
                    sx={{ color: "white", fontSize: "40px", cursor: "pointer" }}
                  />
                </button>
              }
            </Box>
            {pictures?.length > 0 && (
              <Fragment>
                <Box sx={{ position: "relative" }}>
                  <ReactImageMagnify
                    {...{
                      smallImage: {
                        src: pictures[imageIndex]?.includes("https")
                          ? pictures[imageIndex]
                          : process.env.REACT_APP_IMAGE_BASE_URL +
                          pictures[imageIndex],
                        isFluidWidth: true,
                      },
                      largeImage: {
                        src: pictures[imageIndex]?.includes("https")
                          ? pictures[imageIndex]
                          : process.env.REACT_APP_IMAGE_BASE_URL +
                          pictures[imageIndex],
                        width: 1200,
                        height: 1200,
                      },
                      isHintEnabled: true,
                      shouldHideHintAfterFirstActivation: false,
                    }}
                  />
                  <Box
                    sx={{ position: "absolute", left: "10px", bottom: "10px" }}
                  >
                    <Box sx={{ mb: 1 }} onClick={() => setOpen(true)}>
                      <Tooltip title={"Full Screen"} placement="right-start">
                        <IconButton
                          size="small"
                          sx={{
                            borderRadius: "10px",
                            bgcolor: Colors.darkGrey,
                            "&:hover": { bgcolor: Colors.darkGrey },
                          }}
                        >
                          <FullscreenOutlined sx={{ color: Colors.white }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                    {/* <Box sx={{ mb: 1 }}>
                      <Tooltip title={"View HD"} placement="right-start">
                        <IconButton
                          size="small"
                          sx={{
                            borderRadius: "10px",
                            bgcolor: Colors.darkGrey,
                            "&:hover": { bgcolor: Colors.darkGrey },
                          }}
                        >
                          <HdOutlined sx={{ color: Colors.white }} />
                        </IconButton>
                      </Tooltip>
                    </Box> */}
                    <Box>
                      <Tooltip title={"Download"} placement="right-start">
                        <IconButton
                          size="small"
                          onClick={() => {
                            const type = "Vehicle Documents";

                            // // Collect only valid (truthy) document URLs
                            // const validDocs = [vccDoc, bl, mobaya, auction, gatepass].filter(Boolean);

                            // If no document exists, just return or alert
                            if (pictures.length === 0) {
                              alert("No documents available to download.");
                              return;
                            }

                            // Join valid URLs with commas
                            const mediaLinks = encodeURIComponent(pictures.join(","));

                            // Build final download URL
                            const downloadUrl = `${process.env.REACT_APP_IMAGE_BASE_URL}/api/system/downloadZip?type=${type}&mediaLinks=${mediaLinks}`;

                            // Open in new tab
                            window.open(downloadUrl, "_blank");
                          }}
                         
                          sx={{
                            borderRadius: "10px",
                            bgcolor: Colors.darkGrey,
                            "&:hover": { bgcolor: Colors.darkGrey },
                          }}
                        >
                          <CloudDownload sx={{ color: Colors.white }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </Box>
                </Box>
                <ImageList sx={{ maxHeight: 200 }} cols={4}>
                  {pictures?.map((item, index) => (
                    <ImageListItem
                      key={index}
                      onClick={() => setImageIndex(index)}
                      sx={{
                        border: `1px solid ${index === imageIndex
                            ? Colors.greyShade
                            : "transparent"
                          }`,
                        borderRadius: 2,
                        alignItems: "center",
                        p: 0.5,
                        cursor: "pointer",
                      }}
                    >
                      <Box
                        component={"img"}
                        src={
                          item?.includes("https")
                            ? item
                            : process.env.REACT_APP_IMAGE_BASE_URL + item
                        }
                        sx={{ height: 85, width: 85, objectFit: "cover" }}
                      />
                    </ImageListItem>
                  ))}
                </ImageList>
              </Fragment>
            )}
          </Grid>

          <Grid
            container
            spacing={3}
            gap={2}
            justifyContent={"center"}
            sx={{ padding: 2 }}
          >
            {(vehicleDetails?.purchase_date ||
              vehicleDetails?.vin ||
              vehicleDetails?.lot_number ||
              vehicleDetails?.veh_make?.name ||
              vehicleDetails?.veh_model?.name ||
              vehicleDetails?.color ||
              vehicleDetails?.year ||
              vehicleDetails?.location?.country_name ||
              vehicleDetails?.location ||
              vehicleDetails?.warehouse?.name ||
              vehicleDetails?.key ||
              vehicleDetails?.title_status ||
              vehicleDetails?.title_receive_date ||
              vehicleDetails?.tower?.name ||
              vehicleDetails?.auctioneer ||
              vehicleDetails?.auction_house?.name ||
              vehicleDetails?.pickup_date ||
              vehicleDetails?.delivery_date) && (
                <Grid
                  item
                  xs={12}
                  sm={3.8}
                  md={3.8}
                  sx={{
                    boxShadow: " 0px 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    height: "fit-content",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 3,
                      borderBottom: "2px solid #001f3f",
                      width: "fit-content",
                    }}
                  >
                    <DirectionsCarRoundedIcon
                      sx={{ color: "#001f3f", fontSize: 28, mr: 1 }}
                    />
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#333",
                        fontWeight: "bold",

                      }}
                    >
                      Vehicle Information
                    </Typography>
                  </Box>

                  {/* Basic Vehicle Details */}
                  {vehicleDetails?.purchase_date && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Purchase Date:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {formatDate(vehicleDetails?.purchase_date)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.vin && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          VIN:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.vin)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.lot_number && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          LOT Number:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.lot_number)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.veh_make?.name && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Make:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.veh_make?.name)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.veh_model?.name && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Model:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.veh_model?.name)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.color && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Color:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.color)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.year && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Year:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.year)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.location?.country_name && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Country:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.location?.country_name)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.location && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Location:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {vehicleDetails?.location
                            ? `${vehicleDetails.location.city_name}`
                            : "N/A"}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.warehouse?.name && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Warehouse:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.warehouse?.name)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.key && vehicleDetails?.key !== "N/A" && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Key:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {vehicleDetails?.key === "N/A"
                            ? "-"
                            : displayValue(vehicleDetails?.key)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.title_status && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Title Status:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.title_status)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.title_receive_date && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Title Received Date:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {formatDate(vehicleDetails?.title_receive_date)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.tower?.name && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Towed By:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.tower?.name)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {/* {vehicleDetails?.auctioneer && (
                  <Box sx={{ display: "flex", mb: 1.5 }}>
                    <Box sx={{ width: "150px" }}>
                      <Typography variant="body1" sx={{ color: "#666" }}>
                        Auctioneer:
                      </Typography>
                    </Box>
                    <Box sx={{ width: "150px" }}>
                      <Typography variant="body1">
                        {displayValue(vehicleDetails?.auctioneer)}
                      </Typography>
                    </Box>
                  </Box>
                )} */}

                  {vehicleDetails?.auction_house?.name && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Auction House:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.auction_house?.name)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.pickup_date && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Pickup Date:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {formatDate(vehicleDetails?.pickup_date)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.delivery_date && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Delivery Date:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {formatDate(vehicleDetails?.delivery_date)}
                        </Typography>
                      </Box>
                    </Box>
                  )}
                </Grid>
              )}

            {/* Additional Details Section */}
            {(vehicleDetails?.engine_number ||
              vehicleDetails?.mileage ||
              vehicleDetails?.selling_price ||
              vehicleDetails?.seats ||
              vehicleDetails?.horsepower ||
              vehicleDetails?.engine_type ||
              vehicleDetails?.transmission ||
              vehicleDetails?.variant ||
              vehicleDetails?.extras ||
              vehicleDetails?.plate_number ||
              vehicleDetails?.container_declaration_number ||
              vehicleDetails?.notes ||
              vehicleDetails?.website_listing !== undefined) && (
                <Grid
                  item
                  xs={12}
                  sm={3.8}
                  md={3.8}
                  sx={{
                    boxShadow: " 0px 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    height: "fit-content",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      mb: 3,
                      borderBottom: "2px solid #001f3f",
                      width: "fit-content",
                    }}
                  >
                    <InfoOutlinedIcon sx={{ color: "#001f3f", fontSize: 28, mr: 1 }} />
                    <Typography
                      variant="h6"
                      sx={{
                        color: "#333",
                        fontWeight: "bold",

                      }}
                    >
                      Additional Details
                    </Typography>
                  </Box>
                  {vehicleDetails?.engine_number && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Engine Number:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.engine_number)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {(
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Mileage:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {vehicleDetails?.mileage ? vehicleDetails?.mileage : 'N/A'}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {(
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Selling Price:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(
                            parseFloat(
                              vehicleDetails?.selling_price || 0
                            ).toFixed(2)
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {(
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Seats:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {vehicleDetails?.seats || 'N/A'}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {(
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Horsepower:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {vehicleDetails?.horsepower || 'N/A'}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.engine_type && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Engine Type:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.engine_type)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.transmission && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Transmission:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.transmission)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.variant && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Variant:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.variant)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.extras && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Extras:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.extras)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.plate_number && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Plate Number:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.plate_number)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.container_declaration_number && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Container Declaration:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(
                            vehicleDetails?.container_declaration_number
                          )}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.notes && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Notes:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {displayValue(vehicleDetails?.notes)}
                        </Typography>
                      </Box>
                    </Box>
                  )}

                  {vehicleDetails?.website_listing !== undefined && (
                    <Box sx={{ display: "flex", mb: 1.5 }}>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1" sx={{ color: "#666" }}>
                          Website Listing:
                        </Typography>
                      </Box>
                      <Box sx={{ width: "150px" }}>
                        <Typography variant="body1">
                          {vehicleDetails?.website_listing ? "Yes" : "No"}
                        </Typography>
                      </Box>
                    </Box>
                  )}


                </Grid>
              )}

            {/* Price Information Section */}
            {(vehicleDetails?.customer ||
              vehicleDetails?.currency ||
              vehicleDetails?.value ||
              vehicleDetails?.other_charges ||
              vehicleDetails?.buy_fee ||
              vehicleDetails?.enivronment_fee ||
              vehicleDetails?.internet_fee ||
              vehicleDetails?.pull_fee ||
              vehicleDetails?.carfax_fee ||
              vehicleDetails?.digital_sales_fee ||
              vehicleDetails?.towing_charges ||
              vehicleDetails?.shipping_charges ||
              vehicleDetails?.clearing_charges) && (
                <Grid
                  item
                  xs={12}
                  sm={3.8}
                  md={3.8}
                  sx={{
                    boxShadow: " 0px 4px 12px rgba(0, 0, 0, 0.1)",
                    borderRadius: "12px",
                    height: "fit-content",
                  }}
                >
                  {/* Customer Information (if exists) */}
                  {vehicleDetails?.customer && (
                    <>
                      <Typography
                        variant="h6"
                        sx={{
                          color: "#333",
                          fontWeight: "bold",
                          mb: 3,
                        }}
                      >
                        Customer Information
                      </Typography>

                      {vehicleDetails?.customer?.name && (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Customer Name:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.customer?.name)}
                            </Typography>
                          </Box>
                        </Box>
                      )}

                      {vehicleDetails?.customer?.ref_id && (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Customer ID:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.customer?.ref_id)}
                            </Typography>
                          </Box>
                        </Box>
                      )}

                      {customerDetails?.uae_phone && (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Contact:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(customerDetails?.uae_phone)}
                            </Typography>
                          </Box>
                        </Box>
                      )}

                      {customerDetails?.email && (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Email:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography
                              variant="body1"
                              sx={{ wordBreak: "break-word" }}
                            >
                              {displayValue(customerDetails?.email)}
                            </Typography>
                          </Box>
                        </Box>
                      )}
                    </>
                  )}

                  {(vehicleDetails?.currency ||
                    vehicleDetails?.value ||
                    vehicleDetails?.other_charges) && (
                      <>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            mb: 3,
                            mt: vehicleDetails?.customer ? 4 : 0,
                            borderBottom: "2px solid #001f3f",
                            width: "fit-content",
                          }}
                        >
                          <MonetizationOnOutlinedIcon sx={{ color: "#001f3f", fontSize: 28, mr: 1 }} />
                          <Typography
                            variant="h6"
                            sx={{
                              color: "#333",
                              fontWeight: "bold",
                              pb: 1,
                            }}
                          >
                            Price Information
                          </Typography>
                        </Box>
                        {vehicleDetails?.currency && (
                          <Box sx={{ display: "flex", mb: 1.5 }}>
                            <Box sx={{ width: "150px" }}>
                              <Typography variant="body1" sx={{ color: "#666" }}>
                                Currency:
                              </Typography>
                            </Box>
                            <Box sx={{ width: "150px" }}>
                              <Typography variant="body1">
                                {displayValue(
                                  vehicleDetails?.currency?.toUpperCase()
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        )}

                        {vehicleDetails?.value && (
                          <Box sx={{ display: "flex", mb: 1.5 }}>
                            <Box sx={{ width: "150px" }}>
                              <Typography variant="body1" sx={{ color: "#666" }}>
                                Value:
                              </Typography>
                            </Box>
                            <Box sx={{ width: "150px" }}>
                              <Typography variant="body1">
                                {displayValue(
                                  parseFloat(vehicleDetails?.value || 0).toFixed(2)
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        )}

                        {vehicleDetails?.other_charges && (
                          <Box sx={{ display: "flex", mb: 1.5 }}>
                            <Box sx={{ width: "150px" }}>
                              <Typography variant="body1" sx={{ color: "#666" }}>
                                Other Charges:
                              </Typography>
                            </Box>
                            <Box sx={{ width: "150px" }}>
                              <Typography variant="body1">
                                {displayValue(
                                  parseFloat(
                                    vehicleDetails?.other_charges || 0
                                  ).toFixed(2)
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                        {(
                          <Box sx={{ display: "flex", mb: 1.5 }}>
                            <Box sx={{ width: "150px" }}>
                              <Typography variant="body1" sx={{ color: "#666" }}>
                                Total Charges:
                              </Typography>
                            </Box>
                            <Box sx={{ width: "150px" }}>
                              <Typography variant="body1">
                                {displayValue(
                                  parseFloat(
                                    vehicleDetails?.value || 0
                                  ) + parseFloat(
                                    vehicleDetails?.other_charges || 0
                                  )
                                )}
                              </Typography>
                            </Box>
                          </Box>
                        )}
                      </>
                    )}

                  {/* Additional Charges Section */}
                  {parseFloat(vehicleDetails?.buy_fee || 0) ||
                    parseFloat(vehicleDetails?.enivronment_fee || 0) ||
                    parseFloat(vehicleDetails?.internet_fee || 0) ||
                    parseFloat(vehicleDetails?.pull_fee || 0) ||
                    parseFloat(vehicleDetails?.carfax_fee || 0) ||
                    parseFloat(vehicleDetails?.digital_sales_fee || 0) ||
                    parseFloat(vehicleDetails?.towing_charges || 0) ||
                    parseFloat(vehicleDetails?.shipping_charges || 0) ||
                    parseFloat(vehicleDetails?.clearing_charges || 0) ? (
                    <>
                      <Typography
                        variant="h6"
                        sx={{
                          color: "#333",
                          fontWeight: "bold",
                          mb: 3,
                          mt: 4,
                        }}
                      >
                        Additional Charges
                      </Typography>

                      {parseFloat(vehicleDetails?.buy_fee) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Buy Fee:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.buy_fee)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}

                      {parseFloat(vehicleDetails?.enivronment_fee) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Environment Fee:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.enivronment_fee)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}

                      {parseFloat(vehicleDetails?.internet_fee) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Internet Fee:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.internet_fee)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}

                      {parseFloat(vehicleDetails?.pull_fee) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Pull Fee:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.pull_fee)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}

                      {parseFloat(vehicleDetails?.carfax_fee) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Carfax Fee:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.carfax_fee)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}

                      {parseFloat(vehicleDetails?.digital_sales_fee) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Digital Sales Fee:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.digital_sales_fee)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}

                      {parseFloat(vehicleDetails?.towing_charges) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Towing Charges:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.towing_charges)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}

                      {parseFloat(vehicleDetails?.shipping_charges) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Shipping Charges:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.shipping_charges)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}

                      {parseFloat(vehicleDetails?.clearing_charges) ? (
                        <Box sx={{ display: "flex", mb: 1.5 }}>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1" sx={{ color: "#666" }}>
                              Clearing Charges:
                            </Typography>
                          </Box>
                          <Box sx={{ width: "150px" }}>
                            <Typography variant="body1">
                              {displayValue(vehicleDetails?.clearing_charges)}
                            </Typography>
                          </Box>
                        </Box>
                      ) : (
                        ""
                      )}
                    </>
                  ) : (
                    ""
                  )}
                </Grid>
              )}
          </Grid>
        </Grid>
      </Box>
      <Box sx={{ p: 2, borderRadius: 3 }}>
        <Grid container sx={{ gap: "15px" }}>
          {state?.shipping && (
            <Fragment>
              <Grid item xs={12} sm={12}>
                <Typography
                  variant="h5"
                  sx={{
                    color: Colors.charcoalGrey,
                    fontFamily: FontFamily.NunitoRegular,
                    mb: 4,
                  }}
                >
                  Container Information
                </Typography>
              </Grid>
              <Grid
                item
                xs={12}
                sm={3.8}
                sx={{
                  backgroundColor: Colors.white,
                  borderRadius: "15px",
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A;",
                  padding: "15px !important",
                  borderLeft: "2px solid #9B9B9B1A",
                }}
              >
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Container No:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.container_no ?? "-"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Container Size:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.shipping?.container?.name ??
                        "-"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Booking No:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.shipping?.booking_no ?? "-"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Shipping Line:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.shipping?.ship_line?.name ??
                        "-"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Vendor Yard:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.shipping?.vendor_yard ?? "-"}
                    </Typography>
                  </Box>
                </Box>
                {/* <Box sx={{ display: "flex", mb: 1.5 }}>
									<Box sx={{ width: "150px" }}>
										<Typography
											variant="body1"
											sx={{ color: Colors.smokeyGrey }}
										>
											Service Provider:
										</Typography>
									</Box>
									<Box sx={{ width: "150px" }}>
										<Typography
											variant="body1"
											sx={{ fontFamily: FontFamily.NunitoRegular }}
										>
											{vehicleDetails?.vehicle?.shipping?.service?.name ??
												"-"}
										</Typography>
									</Box>
								</Box> */}
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Loading Port:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.shipping?.loading_port?.name ??
                        "-"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={3.8}
                sx={{
                  backgroundColor: Colors.white,
                  borderLeft: "",
                  borderRadius: "15px",
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A;",
                  padding: "15px !important",
                  borderLeftColor: "5px solid #9B9B9B1A",
                }}
              >
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Country:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.location?.country_name ?? "-"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      State:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.location?.state_name ?? "-"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Destination:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.shipping?.dest?.name ?? "-"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Shipping Vendor:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.shipping?.ship_vendor?.name}
                    </Typography>
                  </Box>
                </Box>

                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Cleared By:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.shipping?.clearer?.name}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sm={3.8}
                sx={{
                  backgroundColor: Colors.white,
                  borderLeft: "",
                  borderRadius: "15px",
                  boxShadow: "0px 8px 18px 0px #9B9B9B1A;",
                  padding: "15px !important",
                }}
              >
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Loading Date:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.loading_date
                        ? moment(vehicleDetails?.vehicle?.loading_date).format(
                          "DD-MM-YYYY"
                        )
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Export Date:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.export_date
                        ? moment(vehicleDetails?.vehicle?.export_date).format(
                          "DD-MM-YYYY"
                        )
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      ETA:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.eta
                        ? moment(vehicleDetails?.vehicle?.eta).format(
                          "DD-MM-YYYY"
                        )
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Arrived At Port Date:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.arrived_port_date
                        ? moment(
                          vehicleDetails?.vehicle?.arrived_port_date
                        ).format("DD-MM-YYYY")
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Arrived At Mango Use Cars Yard Date:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.arrived_galaxy_date
                        ? moment(
                          vehicleDetails?.vehicle?.arrived_galaxy_date
                        ).format("DD-MM-YYYY")
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Date Picked From Auction:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.picked_auction_date
                        ? moment(
                          vehicleDetails?.vehicle?.picked_auction_date
                        ).format("DD-MM-YYYY")
                        : "N/A"}
                    </Typography>
                  </Box>
                </Box>
                <Box sx={{ display: "flex", mb: 1.5 }}>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.smokeyGrey }}
                    >
                      Mango Use Cars Yard:
                    </Typography>
                  </Box>
                  <Box sx={{ width: "150px" }}>
                    <Typography
                      variant="body1"
                      sx={{ fontFamily: FontFamily.NunitoRegular }}
                    >
                      {vehicleDetails?.vehicle?.g_yard?.name ?? "-"}
                    </Typography>
                  </Box>
                </Box>
              </Grid>

              <Grid sm={12} sx={{ display: "flex", gap: "15px" }}>
                <Grid
                  item
                  xs={12}
                  sm={3.5}
                  sx={{
                    backgroundColor: Colors.white,
                    borderLeft: "",
                    borderRadius: "15px",
                    boxShadow: "0px 8px 18px 0px #9B9B9B1A;",
                    padding: "15px !important",
                  }}
                >
                  <Box sx={{ mb: 1.5 }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.charcoalGrey }}
                    >
                      BL
                    </Typography>
                    {vehicleDetails?.vehicle?.bl ? (
                      <UploadedFile
                        data={{
                          name: "BL",
                          file: vehicleDetails?.vehicle?.bl,
                        }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </Box>
                  <Box sx={{ mb: 1.5 }}>
                    <Typography
                      variant="body1"
                      sx={{ color: Colors.charcoalGrey }}
                    >
                      Invoice
                    </Typography>
                    {vehicleDetails?.vehicle?.auction_invoice ? (
                      <UploadedFile
                        data={{
                          name: "Invoice",
                          file: vehicleDetails?.vehicle?.auction_invoice,
                        }}
                      />
                    ) : (
                      "N/A"
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Fragment>
          )}
          <Grid
            className="notes-div"
            item
            xs={12}
            sm={12}
            sx={{
              boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.1)",
              backgroundColor: "#fcfcfc",
              padding: "10px",
              width: "50%",
              borderRadius: "15px",
              p: 4,
            }}
          >
            <Typography variant="subtitle1" sx={{ color: Colors.smokeyGrey }}>
              Notes
            </Typography>
            <Grid xs={6}>
              <Typography
                variant="body1"
                sx={{ fontFamily: FontFamily.NunitoRegular }}
              >
                {vehicleDetails?.notes ?? ""}
              </Typography>
            </Grid>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ mt: 2, textAlign: "right" }}>
            <PrimaryButton
              title="Back"
              style={{ backgroundColor: Colors.greyShade }}
              onClick={() => navigate(-1)}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  );
}

export default VehicleBookingDetail;
